import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "pa-0 ma-0" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_select_filled, _mergeProps({
        modelValue: _ctx.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value) = $event)),
        items: _ctx.items,
        attach: "",
        chips: "",
        "return-object": "",
        label: _ctx.label,
        multiple: "",
        readonly: "",
        "single-line": "",
        "hide-details": _ctx.hideDetails,
        class: _ctx.selectClass,
        disabled: _ctx.disabled,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openDialog())),
        density: "compact",
        "item-title": "name"
      }, _ctx.vSelectProps ?? {}), {
        selection: _withCtx(({ item, index }) => [
          (index === 0)
            ? (_openBlock(), _createBlock(_component_v_chip, {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openDialog()))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(item.name.length > _ctx.chipMaxLength
                            ? item.name.substring(0, _ctx.chipMaxLength) + "..."
                            : item.name), 1)
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          (index === 1)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: "text-grey caption",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openDialog()))
              }, "(+" + _toDisplayString(_ctx.value.length - 1) + " autre" + _toDisplayString(_ctx.value.length === 2 ? "" : "s") + ")", 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 16, ["modelValue", "items", "label", "hide-details", "class", "disabled"]),
      (_ctx.dialogCompanySelection)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 0,
            modelValue: _ctx.dialogCompanySelection,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dialogCompanySelection) = $event)),
            "max-width": !_ctx.$vuetify.display.mobile ? '800px' : undefined,
            "min-height": !_ctx.$vuetify.display.mobile ? '300px' : undefined,
            fullscreen: _ctx.$vuetify.display.mobile,
            "hide-overlay": _ctx.$vuetify.display.mobile,
            title: 'Sélectionnez une société',
            prefixDataCy: "ossCompanySelector-valid"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, {
                class: "pt-3",
                style: {"min-width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field_filled, {
                    modelValue: _ctx.companySearch,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.companySearch) = $event)),
                    items: [],
                    outlined: "",
                    label: "Entrez le nom d'une société",
                    autofocus: "",
                    density: "compact",
                    "data-cy": "OssCompanySelector-search"
                  }, null, 8, ["modelValue"]),
                  (_ctx.multiple)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 0,
                        "no-gutters": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "6",
                            class: "d-flex justify-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                variant: "plain",
                                color: "primary",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectAll()))
                              }, {
                                default: _withCtx(() => [
                                  _cache[9] || (_cache[9] = _createTextVNode(" Tout sélectionner ")),
                                  _createVNode(_component_v_icon, {
                                    color: "primary",
                                    right: ""
                                  }, {
                                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                                      _createTextVNode("$check_box")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "6",
                            class: "d-flex justify-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                variant: "plain",
                                color: "primary",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.clearAll()))
                              }, {
                                default: _withCtx(() => [
                                  _cache[11] || (_cache[11] = _createTextVNode(" Tout désélectionner ")),
                                  _createVNode(_component_v_icon, {
                                    color: "primary",
                                    right: ""
                                  }, {
                                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                                      _createTextVNode("$check_box_outline_blank")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_list, {
                    "data-cy": "OssCompanySelector-companies",
                    style: {"overflow-y":"auto"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (company, index) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: index,
                          onClick: ($event: any) => (_ctx.isAdd(company)),
                          class: "mb-2",
                          "data-cy": 'OssCompanySelector-select-' + index,
                          border: "sm",
                          rounded: "lg"
                        }, {
                          append: _withCtx(() => [
                            (_ctx.isSelected(company))
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 0,
                                  color: "primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.multiple ? "$check_box" : "$radio_button_checked"), 1)
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.multiple
                                        ? "$check_box_outline_blank"
                                        : "$radio_button_unchecked"), 1)
                                  ]),
                                  _: 1
                                }))
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "text-wrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.getCompanyDisplayName(company)), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_list_item_subtitle, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Siret: " + _toDisplayString(_ctx.getSiretValue(company.sire)), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "data-cy"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "max-width", "min-height", "fullscreen", "hide-overlay"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}